<template>
	<div class="mb-4 flex">
		<div class="w-1/5 password-strength-meter-bar mr-1" :style="{ background: barColor[0] }"></div>
		<div class="w-1/5 password-strength-meter-bar ml-1 mr-1" :style="{ background: barColor[1] }"></div>
		<div class="w-1/5 password-strength-meter-bar ml-1 mr-1" :style="{ background: barColor[2] }"></div>
		<div class="w-1/5 password-strength-meter-bar ml-1 mr-1" :style="{ background: barColor[3] }"></div>
		<div class="w-1/5 password-strength-meter-bar ml-1" :style="{ background: barColor[4] }"></div>
	</div>
</template>

<script>
export default {
	name: 'PasswordStrengthMeter',
	props: {
		standardBarColor: {
			type: String,
			default: '#aaaaaa',
		},
		optionalBarColor: {
			type: String,
			default: '#ffdd00',
		},
		dangerBarColor: {
			type: String,
			default: '#aa0000',
		},
		successBarColor: {
			type: String,
			default: '#00aa00',
		},
	},
	data() {
		return {
			barColor: [this.standardBarColor, this.standardBarColor, this.standardBarColor, this.standardBarColor, this.standardBarColor],
		};
	},
	methods: {
		checkPasswordStrength: function($event) {
			this.value = $event;
			let strengthMeter = 0;
			let newBarColor = '#aa0000';
			this.resetBarColor();

			if (this.value.length > 7) {
				strengthMeter++;
			}

			if (this.value.match(/[a-z]/)) {
				strengthMeter++;
			}

			if (this.value.match(/[A-Z]/)) {
				strengthMeter++;
			}

			if (this.value.match(/[0-9]/)) {
				strengthMeter++;
			}

			if (this.value.match(/[^A-Za-z0-9]/)) {
				strengthMeter++;
			}

			if (strengthMeter === 5) {
				newBarColor = this.optionalBarColor;

				if (this.value.length > 11) {
					newBarColor = this.successBarColor;
				}
			}

			for (let i = 0; i < strengthMeter; i++) {
				this.$set(this.barColor, i, newBarColor);
			}

			return strengthMeter;
		},
		resetBarColor: function() {
			for (let i = 0; i < 5; i++) {
				this.$set(this.barColor, i, this.standardBarColor);
			}
		},
	},
};
</script>

<style scoped></style>
